import React from 'react';
import { Quote, Star } from 'lucide-react';

const ReviewCard = ({ name, setType, review, rating = 5, image }) => {
    return (
        <div className="bg-white p-8 rounded-2xl card-shadow relative group">
            <Quote className="absolute top-4 right-8 w-16 h-16 text-purple-100 group-hover:text-purple-200 transition-colors opacity-10" />

            <div className="flex items-center gap-4 mb-6 relative z-10">
                <img src={image} alt={name} className="w-12 h-12 rounded-full object-cover" />
                <div>
                    <h4 className="font-bold text-gray-900">{name}</h4>
                    <p className="text-xs text-gray-500 uppercase tracking-widest">{setType}</p>
                </div>
            </div>

            <p className="text-gray-600 leading-relaxed mb-6 relative z-10">"{review}"</p>

            <div className="flex text-yellow-400 gap-1">
                {[...Array(5)].map((_, i) => (
                    <Star key={i} className={`w-4 h-4 ${i < rating ? 'fill-current' : 'text-gray-300'}`} />
                ))}
            </div>
        </div>
    );
};

export default ReviewCard;
